"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
var design_system_theme_1 = require("@unmind/design-system-theme");
var polished_1 = require("polished");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var typography_1 = require("../typography");
var BadgeSizeStyles = (_a = {},
    _a['small'] = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    padding: 6px 10px;\n  "], ["\n    font-size: ", ";\n    padding: 6px 10px;\n  "])), (0, polished_1.rem)(design_system_theme_1.FontSizes.fontSize12)),
    _a['medium'] = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    padding: 6px 12px;\n  "], ["\n    font-size: ", ";\n    padding: 6px 12px;\n  "])), (0, polished_1.rem)(design_system_theme_1.FontSizes.fontSize12)),
    _a['large'] = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n    padding: 6px 12px;\n  "], ["\n    font-size: ", ";\n    padding: 6px 12px;\n  "])), (0, polished_1.rem)(design_system_theme_1.FontSizes.fontSize14)),
    _a['xLarge'] = (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n    padding: 6px 12px;\n  "], ["\n    font-size: ", ";\n    padding: 6px 12px;\n  "])), (0, polished_1.rem)(design_system_theme_1.FontSizes.fontSize16)),
    _a);
var BadgeTypeStyles = (_b = {},
    _b['success'] = (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n  "], ["\n    background-color: ", ";\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.background.success;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.staticPalette.black;
    }),
    _b['warning'] = (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n  "], ["\n    background-color: ", ";\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.background.warning;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.staticPalette.black;
    }),
    _b['error'] = (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n  "], ["\n    background-color: ", ";\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.background.error;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.staticPalette.black;
    }),
    _b);
var BadgeLabel = (0, styled_components_1.default)(typography_1.BodyText)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: inline-block;\n  line-height: 1;\n  border: ", ";\n  border-radius: 20px;\n  ", ";\n  ", ";\n"], ["\n  display: inline-block;\n  line-height: 1;\n  border: ", ";\n  border-radius: 20px;\n  ", ";\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return "1px solid ".concat(theme.colors.staticPalette.black);
}, function (_a) {
    var type = _a.type;
    return BadgeTypeStyles[type];
}, function (_a) {
    var $size = _a.$size;
    return BadgeSizeStyles[$size];
});
/**
 * A badge component used for indicating success, warning or error states.
 */
var Badge = function (_a) {
    var label = _a.label, _b = _a.type, type = _b === void 0 ? 'success' : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c;
    return (react_1.default.createElement(BadgeLabel, { "$size": size, type: type }, label));
};
exports.Badge = Badge;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
